import { DsLibMainMenuSectionInterface } from '@sixense/ds-lib-main-menu';
import { BydUserRightsEnum } from '@sixense/ds-roazhon-service';

export const DS_DOCUMENTATION_MENU: DsLibMainMenuSectionInterface = {
  title: 'menu.documentation',
  expandable: false,
  expanded: false,
  icon: 'support',
  link: {
    title: '',
    url: 'https://users-prod.beyond-platform.com/bienvenue/beyond-insite/',
    disabled: false,
  },
  rights: [BydUserRightsEnum.DEFAULT],
  external: true,
};
